// export const RADIO_OPTIONS = [
//   {
//     value: 'global',
//     text: 'All',
//     textCN: '全部',
//   },
// ];

export const RADIO_OPTIONS = [];
